module.exports = __webpack_public_path__ + "static/media/MNNlong.eb2b0bbf.png";